import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosPrivate from "../../services/axios/axiosPrivate";
import api from "../../services/api";

export const fetchUserPerRole = createAsyncThunk('UserRole/fetchById',
    async (id, { rejectWithValue }) => {
        try {
            const url = `${api.roles.getById}${id}`;
            const response = await axiosPrivate.get(url);
            return response.data.data;
        } catch(error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

const getUserPerRoleSlice = createSlice({
    name: "userPerRole",
    initialState: {
        usersPerRole: [],
        status: "idle",
        loading: true,
        error: false
    },
    reducers: {},
    extraReducers: (builders) => {
        builders
            .addCase(fetchUserPerRole.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                    state.error = null;
                })
            .addCase(fetchUserPerRole.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.loading = false;
                    state.usersPerRole = action.payload;
                })
            .addCase(fetchUserPerRole.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.loading = false;
                    state.error = action.payload;
                }
            )
    }
})  

export default getUserPerRoleSlice.reducer;